export const MANUALPAYMENT = "MANUALPAYMENT";
